module.exports = __webpack_public_path__ + "static/img/case_15.05d2e9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_15.jpg
// module id = FLyX
// module chunks = 0